import { useSyncExternalStore } from 'react';

/** A tiny global store, for dialogs that can be opened from anywhere. */
export function createStore<T>(initial: T) {
  let value = initial;
  const subs = new Set<() => void>();
  return {
    get: () => value,
    set(next: T) {
      value = next;
      subs.forEach((s) => s());
    },
    use(): T {
      return useSyncExternalStore(
        (cb) => {
          subs.add(cb);
          return () => subs.delete(cb);
        },
        () => value,
      );
    },
  };
}
